import { MODEL_FIELD_TYPES } from 'app/generated/modelFieldTypes'
import type { RootStore } from 'app/stores/RootStore'
import { coerce } from './eventPatch'

// Dispatches a WebSocket Event to the matching MobX store. Drops the event when
// the entity type has no store or its id is not already loaded, so the UI only
// patches objects the user is currently looking at.

export type EventRouterPayload = {
  type: string
  action: string
  typeId: string
  data: Record<string, { to?: unknown }>
}

export function eventRouter(rootStore: RootStore, payload: EventRouterPayload): void {
  const { type, action, typeId, data } = payload

  const store = rootStore.storeForEventType(type)
  if (!store) return

  const loaded = store.list?.hits.some((h) => h.id === typeId) || store.current?.id === typeId
  if (!loaded) return

  if (action === `deleted`) {
    store.remove(typeId)
    return
  }

  store.applyPatch(typeId, coerce(data, MODEL_FIELD_TYPES[type] ?? {}))
}
